import { __rest } from 'tslib';
import React from 'react';
import { Box } from '@10d/tend-ui-grid';
import { Root } from './components/Root/Root.js';
import { Header } from './components/Header/Header.js';
import { Footer } from './components/Footer/Footer.js';
import { Body } from './components/Body/Body.js';
import { CloseButton } from './components/CloseButton/CloseButton.js';
import { Title } from './components/Title/Title.js';
import { Description } from './components/Description/Description.js';

const Drawer = (_a) => {
    var { title, description, children, footer } = _a, props = __rest(_a, ["title", "description", "children", "footer"]);
    return (React.createElement(Root, Object.assign({}, props),
        React.createElement(Header, null,
            React.createElement(Box, { "$display": 'flex', "$flexDirection": 'column' },
                title && React.createElement(Title, null, title),
                description && React.createElement(Description, null, description)),
            React.createElement(CloseButton, null)),
        React.createElement(Body, null, children),
        React.createElement(Footer, null, footer)));
};
Drawer.displayName = 'Drawer';
Drawer.Root = Root;
Drawer.Header = Header;
Drawer.Body = Body;
Drawer.Footer = Footer;
Drawer.CloseButton = CloseButton;
Drawer.Title = Title;
Drawer.Description = Description;

export { Drawer };
